import $ from 'jquery';
import {updateLoginBoxNamesLhs} from '../commons/loginbox/name';
import {MARKET} from 'Utils/market.constants';

const initLastConnectionMessage = function () {
    const COOKIE_LAST_CONNECTION = "lastDate";
    const COOKIE_LAST_MEDIA = "lastMedia";
    //const MESSAGE_DURATION = 5000;

    // Function to get a cookie
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts
                .pop()
                .split(";")
                .shift();
        }
        return "";
    }

    function deleteCookie(name) {
        document.cookie = `sg-website-assets=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }

    var cookieLastConnection = getCookie(COOKIE_LAST_CONNECTION);
    var cookieLastMedia = getCookie(COOKIE_LAST_MEDIA);

    if (cookieLastConnection && cookieLastConnection.length >= 12) {
        var year = cookieLastConnection.substring(0, 4);
        var month = cookieLastConnection.substring(4, 6);
        var day = cookieLastConnection.substring(6, 8);
        var hour = cookieLastConnection.substring(8, 10);
        var minute = cookieLastConnection.substring(10, 12);

        var media;

        switch(cookieLastMedia) {
            case 'WAP' :
                media = 'sur Services Mobiles';
                break;
            case 'VOC' :
                media = 'au 3933';
                break;
            default :
                media = 'par Internet';
        }

        var clientName = updateLoginBoxNamesLhs();
        var message;

        if(MARKET.CODE === 1){
            message = `Bonjour ${clientName} ! Dernière connexion ${media} le ${day}/${month}/${year} à ${hour}h${minute}.`;
        }else{
            message = `Dernière connexion ${media} le ${day}/${month}/${year} à ${hour}h${minute}`;
        }


        $("#lastConnectionMessage").text(message);

        if($("#lastConnectionBanner").length > 0) {
            $("#lastConnectionBanner").show();

            // Delete cookie on show message and auto hide after 5 seconds
            deleteCookie(COOKIE_LAST_CONNECTION);
            // setTimeout(function () {
            //     $("#lastConnectionBanner").hide();
            // }, MESSAGE_DURATION);
        }

        // remove the message, and the cookie not to display it again during the session
        $('#lastConnectionBanner div button').on('click', function(e) {
            e.preventDefault();
            $("#lastConnectionBanner").hide();
        });
    }
};

export {initLastConnectionMessage};


// WEBPACK FOOTER //
// ./src/js/cms/commons/last-connection-message.js